import {formatMoney} from 'accounting';
import {Component} from 'react';
import injectSheet from 'react-jss';

import BypassAuthButton from '-/components/fields/BypassAuthButton';
import Button from '-/components/general/Button';
import greetingStyles from '-/styles/sections/greeting';
import StipsHeader from '-/components/general/StipsHeader';
import StipsService from '-/services/StipsService';
import {formatAppointmentDate, getIsolatedStipType, getOppositeApplicant, isStipsBypassMode} from '-/util/util';

class StipsLanding extends Component {
    componentDidMount() {
        if (isStipsBypassMode()) {
            const {onNextClick} = this.props;

            onNextClick();
        }
    }

    render() {
        const {
            auth: {
                authInfo,
                authType,
                showBypassAuthButton
            } = {},
            classes = {},
            dealInfo: {
                lifeTimeSavings
            } = {},
            onNextClick,
            stips: {
                allStipsVerifiedForApplicant,
                allStipsSubmittedForApplicant,
                allStipsSubmitted,
                appointmentDate,
                requestStatus,
                stipsToResubmit
            } = {},
            vehicleInfo = {},
            coAppUnlocked,
            oppositeApplicantName,
            applicantType,
            applicantName,
            timezone
        } = this.props;

        let buttonText, p1, p2 = null;
        let greeting = `Welcome Back, ${applicantName}`;
        let showStipsHeader = false;

        switch (requestStatus) {
            case 'REQUESTED': {
                buttonText = 'Check Status / Upload Documents';
                if (stipsToResubmit) {
                    p1 = <span>We need you to re-submit some documents.</span>;
                } else {
                    p1 = <span>You just need to upload a few more documents before your appt.</span>;
                }
                break;
            }
            case 'ANSWERED':
                buttonText = 'Check Status / Upload Documents';
                p1 = <span>You only have a few more documents to upload.</span>;
                break;
            case 'REQUESTEDFIRSTTIME':
            default:
                buttonText = 'Upload Documents';
                p1 = <span>Congratulations on getting approved!</span>;
                p2 = 'We only need a few documents before your appointment.';
                break;
        }

        if (allStipsSubmittedForApplicant) {
            p1 = <span>All your documents have been uploaded.</span>;
            p2 = 'To find out the status of your uploaded documents click below.';
            buttonText = 'Check Status';
        }

        if (allStipsVerifiedForApplicant) {
            p1 = (
                <b>
                    All your documents have been verified.
                    {appointmentDate && (
                        <span>
                            <br /><br />
                            We look forward to seeing you at your appointment on {formatAppointmentDate(appointmentDate, timezone)}.
                        </span>
                    )}
                </b>
            );
            p2 = null;
        }

        let isolatedStipType = getIsolatedStipType();
        if (Array.isArray(isolatedStipType)) {
            isolatedStipType = isolatedStipType.join(',');
        }

        if (isolatedStipType) {
            const stipTypes = isolatedStipType.split(',');

            if (stipTypes.length > 1) {
                p1 = (
                    <span>
                        We need some additional information and documents so we can continue your application!
                    </span>
                );
                p2 = null;
                buttonText = 'Provide Additional Information/Documents';
            } else if (stipTypes.includes('VIN')) {
                p1 = (
                    <span>
                        Let us know your vehicle&apos;s VIN so we can continue with your application!
                    </span>
                );
                p2 = null;
                buttonText = 'Input VIN';
            } else if (stipTypes.includes('REG')) {
                p1 = (
                    <span>
                        Upload your vehicle&apos;s Registration Certificate so we can continue with your application!
                    </span>
                );
                p2 = null;
                buttonText = 'Upload Registration Certificate';
            } else if (stipTypes.includes('OLD')) {
                p1 = (
                    <span>
                        Upload a copy of your current vehicle loan contract so we can continue with your application! Please make sure you send the entire document.
                    </span>
                );
                p2 = null;
                buttonText = 'Upload Vehicle Contract';
            }

            if (allStipsSubmittedForApplicant) {
                showStipsHeader = true;
                greeting = 'Documents Submitted';
                buttonText = 'Close';

                const {year, make, model}  = vehicleInfo || {};
                let vehicleMessage = null;
                if (year && make && model) {
                    vehicleMessage = ` for the ${year} ${make} ${model}`;
                }

                if (stipTypes.length > 1) {
                    p1 = <span>Thank you for submitting your documents!.</span>;
                } else if (stipTypes.includes('VIN')) {
                    p1 = <span>Thank you for submitting your VIN{vehicleMessage}.</span>;
                } else if (stipTypes.includes('REG')) {
                    p1 = <span>Thank you for submitting your Vehicle Registration{vehicleMessage}.</span>;
                } else if (stipTypes.includes('OLD')) {
                    p1 = <span>Thank you for submitting your Vehicle Contract{vehicleMessage}.</span>;
                }

                p2 = (
                    <span>
                        Within 24 to 48 hours you will hear back about your final loan
                        decision from somone on our team.
                    </span>
                );
            }
        }

        let p3 = lifeTimeSavings ? <p className={classes.p}>You are one step closer to interest savings of about <b>{formatMoney(lifeTimeSavings)}</b>.</p> : '';
        if (lifeTimeSavings < 1000) {
            p3 = <p className={classes.p}>You are one step closer to great interest savings!</p>;
        }

        const oppositeApplicantType = getOppositeApplicant(applicantType);
        const showUploadStipsButton = allStipsSubmittedForApplicant && coAppUnlocked && !allStipsSubmitted;

        return (
            <section className={classes.root}>
                <h1>{greeting}</h1>
                {showStipsHeader && <StipsHeader />}
                <p className={classes.p}>{p1}</p>
                <p className={classes.p}>{p2}</p>
                {!allStipsVerifiedForApplicant && !showBypassAuthButton && (
                    <Button
                        width={90}
                        tag="a"
                        href="#"
                        onClick={onNextClick}
                        title={buttonText}
                        role="button">
                        {buttonText}
                    </Button>
                )}
                {showUploadStipsButton && (
                    <Button
                        width={90}
                        tag="a"
                        href="#"
                        btnStyle="alternate"
                        className="main"
                        onClick={() => {
                            StipsService.setApplicantType(oppositeApplicantType);
                            onNextClick();
                        }}
                        title={buttonText}
                        role="button">
                        Upload Stips for {oppositeApplicantName}
                    </Button>
                )}
                {showBypassAuthButton && (
                    <BypassAuthButton
                        authType={authType}
                        authInfo={authInfo}
                        buttonText={buttonText} />
                )}
                {p3}
                {lifeTimeSavings > 0 && (
                    <p className={classes.p}>
                        <b>{'"Not too bad for a few minutes work."'}</b>
                    </p>
                )}
            </section>
        );
    }
}

export default injectSheet(greetingStyles)(StipsLanding);
